import { 
  Box, 
  Spinner, 
  VStack, 
  Text, 
  useColorModeValue 
} from '@chakra-ui/react'
import { useEffect } from 'react'

export default function Login() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://app.vehiclelogi.com'
    }, 500) // Small delay to ensure smooth transition

    return () => clearTimeout(timer)
  }, [])

  const bgColor = useColorModeValue('white', 'gray.900')
  const textColor = useColorModeValue('gray.800', 'white')

  return (
    <Box 
      position="fixed" 
      top={0} 
      left={0} 
      width="100%" 
      height="100%" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      bg={bgColor}
      color={textColor}
      zIndex={9999}
    >
      <VStack spacing={4}>
        <Spinner 
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text fontSize="xl" fontWeight="bold">
          Redirecting to VehicleLogi App...
        </Text>
      </VStack>
    </Box>
  )
}